<form class="card mt-2" *ngIf="canEdit">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h5 class="mb-2">Assign To</h5>
      </div>
      <div class="col-12 col-xl-4">
        <label class="small text-muted mb-1">Assignment Type</label>
        <p-select styleClass="app-select mt-2" [options]="assignmentTargetOptions" [(ngModel)]="assignmentTargetType" (ngModelChange)="changedAssignmentTarget()" [ngModelOptions]="{standalone: true}" [disabled]="disableAssignControls"></p-select>
      </div>
      <div class="col-12 col-xl-8">
        <label class="small text-muted mb-1">Assignee</label>
        <p-select *ngIf="assignmentTargetType === 'user'" styleClass="app-select mt-2" [options]="usersList" [filter]="true" [resetFilterOnHide]="true" [(ngModel)]="userID" (ngModelChange)="changedUser()" [ngModelOptions]="{standalone: true}" placeholder="Select user..." [disabled]="disableAssignControls"></p-select>
        <p-select *ngIf="assignmentTargetType === 'campus'" styleClass="app-select mt-2" [options]="campusesList" [filter]="true" [resetFilterOnHide]="true" [(ngModel)]="assignedProgramID" (ngModelChange)="changedCampus()" [ngModelOptions]="{standalone: true}" placeholder="Select campus..." [disabled]="disableAssignControls"></p-select>
        <div *ngIf="assignmentTargetType === 'user'" style="font-size:.75rem;" class="mt-2">
          <label for="includeTerminated">Include Separated Employees: </label>
          <p-checkbox id="includeTerminated" name="includeTerminated" styleClass="form-check-input ml-4" [(ngModel)]="includeTerminated" (onChange)="includeTerminatedChange($event)" [binary]="true" [ngModelOptions]="{standalone: true}" [disabled]="disableAssignControls"></p-checkbox>
        </div>
        <small *ngIf="showErrors && !hasSelectedAssignmentTarget()" class="text-danger">Select a {{assignmentTargetType === 'campus' ? 'campus' : 'user'}} to assign the asset</small>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-12">
        <h5 class="mb-2">Select Asset</h5>
        <div class="selected-assets-panel mt-2">
          <div class="selected-assets-header">
            <h6 class="mb-0">Selected Assets</h6>
            <span class="selected-assets-count">{{assigningEquipments?.length || 0}}</span>
          </div>
          <p-table class="small-Text mb-0" [value]="assigningEquipments" [responsive]="true">
            <ng-template pTemplate="header">
              <tr>
                <th width="110px"></th>
                <th width="170px">Return Date</th>
                <th>Group</th>
                <th>Type</th>
                <th>Category</th>
                <th>Description</th>
                <th>Serial</th>
                <th>Barcode</th>
                <th>Source Location</th>
                <th>Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-equipment>
              <tr>
                <td>
                  <button class="btn btn-secondary mr-2" (click)="removeEquipment(equipment)" [disabled]="disableAssignControls">Remove</button>
                </td>
                <td>
                  <div *ngIf="equipment.thereIsReturnDate != false && equipment.thereIsReturnDate != null" class="returndatebuttonwrap">
                    <input type="date" class="form-control mt-2" [min]="currentDate" [(ngModel)]="equipment.returnDateString" (blur)="setReturnDate(equipment)" [ngModelOptions]="{standalone: true}" [disabled]="disableAssignControls" />
                    <button class="returnDateButtonCancel" (click)="removeReturnDate(equipment)" [disabled]="disableAssignControls">x</button>
                  </div>
                  <div class="returndatebuttonwrap" *ngIf="equipment.thereIsReturnDate != true">
                    <button class="returnDateButton" (click)="AddReturnDate(equipment)" [disabled]="disableAssignControls">+</button>
                  </div>
                </td>
                <td>{{equipment.equipment.assetGroups?.length ? equipment.equipment.assetGroups.join(', ') : '-'}}</td>
                <td>{{equipment.equipment.type}}</td>
                <td>{{equipment.equipment.assetCategory}}</td>
                <td>
                  {{equipment.equipment.description}}
                  <span *ngIf="equipment.autoAddedFromGroup" class="badge badge-info ml-2">Auto-added accessory</span>
                </td>
                <td>{{equipment.equipment.serialNumber || '-'}}</td>
                <td>{{equipment.equipment.barcode || '-'}}</td>
                <td>{{equipment.equipment.inventoryAssetLocation || '-'}}</td>
                <td>{{equipment.assetStatus}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="assignment-section-divider mt-3 mb-2"></div>
        <div class="search-assets-header mb-2">Search Assets</div>

        <div class="row mb-4">
          <div class="col-12">
            <small *ngIf="showErrors && assigningEquipments.length < 1" class="text-danger">Add at least one asset to assign</small>
          </div>
          <div class="col-12 col-md-3 d-flex align-items-center">
            <p-select styleClass="app-select w-100 mt-2"
                      [options]="locationList"
                      [filter]="true"
                      [resetFilterOnHide]="true"
                      [(ngModel)]="inventoryAssetLocationID"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="All source locations..."
                      [disabled]="disableAssignControls"></p-select>
          </div>
          <div class="col-12 col-md-3 d-flex align-items-center">
            <p-select styleClass="app-select w-100 mt-2"
                      [options]="assetGroupFilterOptions"
                      [(ngModel)]="assetGroupFilter"
                      (ngModelChange)="onAssetGroupFilterChange()"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="No group filter..."
                      [disabled]="disableAssignControls"></p-select>
          </div>
          <div class="col-10 col-md-5 d-flex align-items-center">
            <p-autoComplete class="w-100" styleClass="w-100 d-flex mt-2" [dropdown]="true" inputStyleClass="form-control" [(ngModel)]="selectedEquipment" [ngModelOptions]="{standalone: true}" [suggestions]="equipmentSearchResult" field="label"
                            [disabled]="disableAssignControls"
                            (completeMethod)="searchEquipment($event)" placeholder="Search by asset type, description, serial, or barcode..."></p-autoComplete>
          </div>
          <div class="col-2 col-md-1 d-flex justify-content-start">
            <div *ngIf="isAlreadyAssigned(selectedEquipment)">
              <button (click)="addEquipment(selectedEquipment)" class="btn btn-secondary mt-2" [disabled]="disableAssignControls">Add</button>
            </div>
          </div>
          <div *ngIf="selectedEquipment && !isAlreadyAssigned(selectedEquipment)">
            <p style="color:red;margin-left:20px;">This asset is already queued above.</p>
          </div>
        </div>

        <div class="card mt-3" *ngIf="showGroupMemberStep">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h6 class="mb-1">Step 2 (optional): Add group members</h6>
                <small class="text-muted">Selected grouped asset: {{groupedSeedDisplayName}}</small>
              </div>
              <button class="btn btn-link p-0" type="button" (click)="toggleGroupMemberStepCollapsed()">
                {{groupMemberStepCollapsed ? 'Show accessories step' : 'Hide accessories step'}}
              </button>
            </div>

            <div *ngIf="groupMemberStepCollapsed" class="small text-muted mt-2">
              Accessories step is hidden. Expand to review or adjust grouped kit members.
            </div>

            <ng-container *ngIf="!groupMemberStepCollapsed">
            <div *ngIf="loadingGroupMembers" class="text-muted mt-2">Loading group members...</div>
            <div *ngIf="!loadingGroupMembers && hasIncompleteGroupedKitSelection" class="alert alert-warning mt-2 mb-2 py-2">
              <div><b>Incomplete kit assignment detected.</b> One or more grouped kit categories are not complete for this assignment.</div>
              <div class="small mt-1" *ngFor="let summary of incompleteGroupedKitCategorySummaries">
                {{summary.category}}: assigning {{summary.selectedCount}} of {{summary.expectedCount}}
                <span *ngIf="summary.hasNoSelectableOptions"> (no available accessories)</span>
              </div>
              <div *ngIf="hasUnavailableGroupedKitCategories" class="small mt-1">
                Some categories currently have no available accessories, so a complete kit cannot be auto-built right now.
              </div>
            </div>

            <div class="row mt-2" *ngIf="!loadingGroupMembers">
              <div class="col-10 col-md-11">
                <p-autoComplete class="w-100" styleClass="w-100 d-flex mt-2"
                                [dropdown]="true"
                                inputStyleClass="form-control"
                                [(ngModel)]="selectedGroupMember"
                                [ngModelOptions]="{standalone: true}"
                                [suggestions]="groupMemberSearchResults"
                                field="label"
                                [disabled]="disableAssignControls"
                                (completeMethod)="completeGroupMemberSearch($event)"
                                placeholder="Search within group members..."></p-autoComplete>
              </div>
              <div class="col-2 col-md-1">
                <div *ngIf="selectedGroupMember">
                  <button (click)="addGroupMember(selectedGroupMember)"
                          class="btn btn-secondary mt-2"
                          [disabled]="disableAssignControls || !canSelectGroupMember(selectedGroupMember)">
                    Add
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="!loadingGroupMembers && groupMembers.length < 1" class="text-muted mt-2">
              No additional group members found for this group and location filter.
            </div>

            <ng-container *ngIf="!loadingGroupMembers && groupMembers.length > 0">
              <div class="mt-3" *ngFor="let categoryGroup of groupMembersByCategory">
                <button type="button"
                        class="btn btn-link p-0 d-flex align-items-center category-collapse-toggle"
                        (click)="toggleCategoryCollapsed(categoryGroup.category)">
                  <i class="fas mr-2" [ngClass]="isCategoryCollapsed(categoryGroup.category) ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
                  <span class="font-weight-bold mr-2">{{categoryGroup.category}} ({{categoryGroup.items.length}})</span>
                  <span class="text-muted">Selected ({{getSelectedCountForCategory(categoryGroup.category)}})</span>
                </button>
                <div *ngIf="getCategoryUnavailableMessage(categoryGroup.category) as unavailableCategoryMessage" class="small text-warning mb-2">
                  {{unavailableCategoryMessage}}
                </div>
                <p-table *ngIf="!isCategoryCollapsed(categoryGroup.category)" class="small-Text" [value]="categoryGroup.items" [responsive]="true">
                  <ng-template pTemplate="header">
                    <tr>
                      <th width="100px"></th>
                      <th>Type</th>
                      <th>Description</th>
                      <th>Serial</th>
                      <th>Barcode</th>
                      <th>Source Location</th>
                      <th>Status</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-member>
                    <tr>
                      <td>
                        <button class="btn btn-secondary"
                                (click)="addGroupMember(member)"
                                [disabled]="disableAssignControls || !canSelectGroupMember(member)">
                          Add
                        </button>
                      </td>
                      <td>{{member.type}}</td>
                      <td>{{member.description}}</td>
                      <td>{{member.serialNumber || '-'}}</td>
                      <td>{{member.barcode || '-'}}</td>
                      <td>{{member.inventoryAssetLocation || '-'}}</td>
                      <td>{{getGroupMemberStatusLabel(member)}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-4">
      <div class="col-12">
        <h5 class="mb-2">Assign</h5>
        <label class="small text-muted mb-1">Note (optional)</label>
        <textarea class="form-control mt-2" rows="3" [(ngModel)]="assignmentNote" [ngModelOptions]="{standalone: true}" placeholder="Optional note for the assignment" [disabled]="disableAssignControls"></textarea>
      </div>
    </div>

    <div class="mt-4 float-right">
      <i *ngIf="savingAssignEquipments" class="material-icons rotate text-muted">loop</i>
      <button *ngIf="!savingAssignEquipments" class="btn btn-primary" (click)="requestSave()" [disabled]="disableAssignControls">{{assignButtonText}}</button>
    </div>
  </div>
</form>

<p-dialog [showHeader]="false" [modal]="true" appendTo="body" [style]="{width: '900px', maxWidth: '96vw'}"
          [closable]="!disableAssignControls" [dismissableMask]="!disableAssignControls" [closeOnEscape]="!disableAssignControls"
          [(visible)]="showAssignConfirmDialog">
  <div class="confirm-dialog-content">
    <div class="confirm-dialog-title">Confirm Assignment</div>
    <p class="confirm-dialog-hint mb-3">
      Review the assignment details below before confirming.
    </p>

    <div class="row">
      <div class="col-12 col-md-6">
        <table class="table table-sm mb-0">
          <tbody>
            <tr>
              <th style="width: 160px;">Assignment Type</th>
              <td>{{assignmentTargetType === 'campus' ? 'Campus' : 'User'}}</td>
            </tr>
            <tr>
              <th>Assignee</th>
              <td>{{getSelectedAssigneeLabel()}}</td>
            </tr>
            <tr>
              <th>Assets Selected</th>
              <td>{{assigningEquipments?.length || 0}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 col-md-6">
        <label class="small text-muted mb-1">Note (optional)</label>
        <textarea class="form-control" rows="3" [(ngModel)]="assignmentNote" [ngModelOptions]="{standalone: true}" placeholder="Optional note for this assignment" [disabled]="disableAssignControls"></textarea>
      </div>
    </div>

    <div class="mt-3">
      <p-table [value]="assigningEquipments" styleClass="small-Text" [responsive]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>Type</th>
            <th>Category</th>
            <th>Description</th>
            <th>Serial</th>
            <th>Barcode</th>
            <th>Return Date</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-equipment>
          <tr>
            <td>{{equipment.equipment.type}}</td>
            <td>{{equipment.equipment.assetCategory}}</td>
            <td>{{equipment.equipment.description}}</td>
            <td>{{equipment.equipment.serialNumber || '-'}}</td>
            <td>{{equipment.equipment.barcode || '-'}}</td>
            <td>{{equipment.returnDateString || '-'}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="hasIncompleteGroupedKitSelection" class="alert alert-warning mt-3 mb-0 py-2">
      <div><b>Incomplete kit assignment confirmation.</b> The following grouped kit categories are not complete in this assignment:</div>
      <div class="small mt-1" *ngFor="let summary of incompleteGroupedKitCategorySummaries">
        {{summary.category}}: assigning {{summary.selectedCount}} of {{summary.expectedCount}}
        <span *ngIf="summary.hasNoSelectableOptions"> (no available accessories)</span>
      </div>
    </div>

    <div class="text-right mt-3">
      <button class="btn btn-primary mr-2" (click)="save()" [disabled]="disableAssignControls">Yes</button>
      <button class="btn btn-secondary" (click)="cancelSave()" [disabled]="disableAssignControls">No</button>
    </div>
  </div>
</p-dialog>
